import React, { useState } from 'react';
import { WechatOutlined } from '@ant-design/icons';
import qrcode from '../assets/images/qrcode.png';

/**
 * 在线客服悬浮组件
 *
 * 右侧固定一个药丸容器,一个 Tab(图标 + 文字):
 *   - 微信咨询 —— hover 时左侧弹出二维码卡片
 */
const ChatWidget = () => {
  // 微信咨询 hover 态 —— true 时左侧弹出二维码卡片
  const [hoverWechat, setHoverWechat] = useState(false);

  return (
    <div className="chat-widget">
      <div className="chat-tab-bar">
        {/* 药丸容器 —— 微信咨询 单条 */}
        <div className="chat-tab-group">
          <button
            type="button"
            className="chat-tab"
            onMouseEnter={() => setHoverWechat(true)}
            onMouseLeave={() => setHoverWechat(false)}
            aria-label="微信咨询"
          >
            <span className="chat-tab-icon-wrap">
              <WechatOutlined />
            </span>
            <span className="chat-tab-label">微信咨询</span>
          </button>
        </div>

        {/* 微信咨询 hover 二维码卡片 —— 放在药丸外面,避免 overflow:hidden 裁掉 */}
        <div
          className={`chat-wechat-popover${hoverWechat ? ' chat-wechat-popover--visible' : ''}`}
          aria-hidden={!hoverWechat}
          onMouseEnter={() => setHoverWechat(true)}
          onMouseLeave={() => setHoverWechat(false)}
        >
          <div className="chat-wechat-popover-qr">
            <img
              src={qrcode}
              alt="微信二维码"
              className="chat-wechat-popover-qr-img"
            />
            <span className="chat-wechat-popover-qr-label"></span>
          </div>
          <div className="chat-wechat-popover-info">
            <div className="chat-wechat-popover-title">微信咨询</div>
            <div className="chat-wechat-popover-subtitle">扫码添加专属顾问</div>
            <div className="chat-wechat-popover-hours">工作日 9:00-18:00</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatWidget;
